<template>
  <div class="payslip">
    <div class="payslip__header">
      <h1>Payslip</h1>
    </div>

    <div class="payslip__body">
      <p class="page__err" v-if="pageErr">{{ pageErr }}</p>

      <div class="page-loader" v-if="pageLoading">
        <div>
          <PageLoader />
        </div>
      </div>

      <div class="payslip__body--container" v-if="!pageLoading">
        <p>This is where you can find all of your payslips and view an in-depth report of each of them below.</p>
        <div class="payslip__body--container-header">
          <div>
            <select v-model="year" @change="selectYear">
              <option v-for="(list, key) in yearsList" :value="list" :key="key">{{ list }}</option>
            </select>
          </div>
        </div>
        <div v-if="payslips.length > 0" class="payslip__body--container-table">
          <div class="payslip__body--container-thead">
            <div>Payslip Title</div>
            <div>Month</div>
            <div>Amount</div>
            <div>Action</div>
          </div>
          <div class="payslip__body--container-tbody">
            <div v-for="pay in payslips" :key="pay.index">
              <div>{{ pay.payroll_title }}</div>
              <div>{{ pay.payment_month }}</div>
              <div>&#8358;{{ pay.amount | payrollValueToCurrency }}</div>
              <div @click="showPayslip(pay.transaction_uuid)">View</div>
            </div>
          </div>
        </div>
        <EmptyContent title="No payslip found" v-else />
      </div>
    </div>
    <div class="payslip__modal" v-if="modal">
      <div>
        <div class="payslip__modal--content" v-if="modalLoading">
          <p>
            <span @click="closePayslip">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div class="page-loader">
            <div>
              <PageLoader />
            </div>
          </div>
        </div>

        <div class="payslip__modal--content" v-if="!modalLoading">
          <p>
            <span @click="closePayslip">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <p v-if="modalErr" class="page__err">{{ $modalErr }}</p>

          <div class="payslip__modal--content-box" id="payslip">
            <div class="payslip__modal--content-header">
              <span>{{ this.payslipDetails.company_name }}</span>
              <ul>
                <li>{{ this.payslipDetails.company_address }}</li>
                <li>{{ this.payslipDetails.company_email }}</li>
              </ul>
            </div>
            <div class="payslip__modal--content-banner">{{ this.payslipDetails.payslip_title }}</div>
            <div class="payslip__modal--content-info">
              <p>
                <span>Your Information:</span>
                {{ this.payslipDetails.employee_name }}
              </p>

              <p>
                <span>Payday:</span>
                {{ this.payslipDetails.pay_date }}
              </p>
            </div>
            <div class="payslip__modal--content-table">
              <table>
                <thead>
                  <tr>
                    <th>Earnings</th>
                    <th>Amount NGN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="comp in payslipDetails.compensations" :key="comp.index">
                    <td>{{ comp.title }}</td>
                    <td>&#8358;{{ comp.amount | payrollValueToCurrency }}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Total Earnings</th>
                    <th>&#8358;{{ this.payslipDetails.total_compensations }}</th>
                  </tr>
                </thead>
              </table>

              <table>
                <thead>
                  <tr>
                    <th>Deductions</th>
                    <th>Amount NGN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ded in payslipDetails.deductibles" :key="ded.index">
                    <td>{{ ded.title }}</td>
                    <td>&#8358;{{ ded.amount | payrollValueToCurrency }}</td>
                  </tr>
                </tbody>
                <thead>
                  <tr>
                    <th>Total Deductions</th>
                    <th>&#8358;{{ this.payslipDetails.total_deductibles | payrollValueToCurrency }}</th>
                  </tr>
                </thead>
              </table>

              <table>
                <thead>
                  <tr>
                    <th>Total</th>
                    <th>Amount NGN</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="row--color">Take Home Pay</td>
                    <td class="row--color">&#8358;{{ this.payslipDetails.net_pay | payrollValueToCurrency }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="payslip__modal--content-pdf">
            <div @click="downloadPdf">Download PDF</div>
            <div @click="closePayslip">Cancel</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import EmptyContent from '../../partials/emptyContent.vue'
import jsPDF from "jspdf";
import { payrollValueToCurrency } from "../../../util/filters";

export default {
  name: "Payslip",

  components: {
    PageLoader,
    EmptyContent
  },

  data() {
    return {
      item: "payslip",
      pageLoading: true,
      modalLoading: true,
      modal: false,
      year: "",
      yearsList: [],
      payslips: [],
      payslipDetails: {},
      pageErr: null,
      modalErr: null
    };
  },
  mounted() {
    this.initiatePage()
  },
  methods: {
    initiatePage() {
      const date = new Date();
      this.year = date.getFullYear();

      this.getPayslipByYear()
    },

    selectYear() {
      this.getPayslipByYear()
    },
    showPayslip(val) {
      this.modalLoading = true;
      this.modal = true;
      this.modalErr = null

      this.$http
        .get(types.EMPLOYEE_PAYSLIP_SHOW + `/${val}`)
        .then(resp => {
          if (resp.data.data) {
            this.payslipDetails = resp.data.data;
            this.modalLoading = false;
          }
        })
        .catch(err => {
          this.modalErr = "Unable to load content";
        });
    },
    getPayslipByYear() {
      this.pageErr = null
      this.pageLoading = true;

      this.$http
        .get(types.EMPLOYEE_PAYSLIP + `?year=${this.year}`)
        .then(resp => {
          const data = resp.data.data
          this.payslips = data.payslips;
          this.yearsList = data.years
          this.pageLoading = false;
        })
        .catch(err => {
          this.pageErr = "Unable to load payslips at the moment."
         });
    },
    closePayslip() {
      this.modal = false;
      this.modalLoading = false;
    },
    downloadPdf() {
      let doc = new jsPDF();
      let elementHTML = document.getElementById("payslip").innerHTML;
      let specialElementHandler = {
        "#payslip__sample": function (element, renderer) {
          return true;
        }
      };

      doc.fromHTML(elementHTML, 15, 15, {
        width: 170,
        elementHandler: specialElementHandler
      });

      doc.save("payslip.pdf");
    }
  },
  filters: {
    payrollValueToCurrency
  }
};
</script>
<style lang="scss" scoped>
.page-loader {
  margin-top: 50px;

  >div {
    width: 55px;
    margin: auto;
  }
}

.error {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 12;
  font-style: italic;

  p {
    margin: 0;
    padding-bottom: 10px;
  }

  p::first-letter {
    text-transform: uppercase;
  }
}

.payslip {
  padding-top: 40px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .payslip__header {
    overflow: hidden;
    padding-bottom: 5px;

    >h1 {
      padding-bottom: 5px;
      margin-left: 15px;
      margin-top: 0;
      font-size: 2em;
      margin-left: 0;
      margin-bottom: 0;
    }
  }

  >.payslip__body {
    border-top: 1px solid #caced5;
    padding: 20px 5px 0 5px;

    >.payslip__body--container {
      >p {
        font-size: 12px;
        font-weight: 300;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000000;
      }

      >.payslip__body--container-header {
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.67;
        letter-spacing: normal;
        text-align: left;
        color: #000;
        margin-bottom: 20px;

        >div {
          width: 150px;
          height: 40px;
          border-radius: 4px;
          box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
          border: solid 1px #d7dae2;
          background-color: #ffffff;
          overflow: hidden;

          >select {
            width: 100%;
            height: 40px;
            border: 0;
            outline: 0;
            padding: 0 5px;
          }
        }
      }

      >.payslip__body--container-table {
        >.payslip__body--container-thead {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          height: 50px;

          >div {
            width: 33.3333333%;
            font-size: 12px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }
        }

        >.payslip__body--container-tbody {
          border-top: 5px solid #5099de;

          >div {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            height: 50px;
            border-radius: 2px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
            margin-bottom: 20px;

            >div {
              width: 33.3333333%;
              font-size: 12px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.17;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
            }

            >div:nth-child(4) {
              color: #5099de;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.payslip__modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  overflow: auto;

  >div {
    max-width: 800px;
    padding: 0 10px;
    margin: 50px auto;

    >.payslip__modal--content {
      background: #ffffff;
      border-radius: 5px;
      padding: 20px;

      @media (max-width: 500px) {
        padding: 10px;
      }

      >p {
        font-size: 20px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.88;
        letter-spacing: normal;
        text-align: right;

        margin-bottom: 10px;

        >span {
          color: #000000;
          cursor: pointer;
        }
      }

      >.payslip__modal--content-box {
        >.payslip__modal--content-header {
          >span {
            padding-bottom: 20px;
            font-size: 32px;
            font-weight: 600;
            color: #000;
          }

          >ul {
            list-style: square;
            padding-left: 20px;
            margin-top: 10px;

            >li {
              font-size: 12px;
              line-height: 30px;
            }
          }
        }

        >.payslip__modal--content-banner {
          font-size: 30px;
          color: #6262a0;
          font-weight: 800;
          text-transform: uppercase;
          font-weight: 300;
          text-align: center;
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 20px;
        }

        >.payslip__modal--content-info {
          padding-top: 20px;

          >p {
            text-align: left;
            color: #f79320;
            font-weight: 600;
            line-height: 1.2;

            >span {
              color: #000;
              font-weight: 500;
              line-height: 1.2;
              color: #000;
            }
          }
        }

        >.payslip__modal--content-table {
          >table {
            margin-top: 20px;

            >thead {
              >tr {
                >th:nth-child(1) {
                  width: 70%;
                  font-size: 12px;
                  line-height: 30px;
                  border: 1px solid #dee2e6;
                  padding: 10px;
                }

                >th:nth-child(2) {
                  width: 30%;
                  font-size: 12px;
                  line-height: 30px;
                  border: 1px solid #dee2e6;
                  padding: 10px;
                }
              }
            }

            >tbody {
              >tr {
                >td:nth-child(1) {
                  width: 70%;
                  font-size: 12px;
                  line-height: 30px;
                  border: 1px solid #dee2e6;
                  padding: 10px;
                }

                >td:nth-child(2) {
                  width: 30%;
                  font-size: 12px;
                  line-height: 30px;
                  border: 1px solid #dee2e6;
                  padding: 10px;
                }

                >.row--color {
                  font-size: 30px;
                  font-weight: 600;
                  color: #f79320;
                }
              }

              >.white--row {
                background-color: #fff;
              }

              >.gray--row {
                background-color: rgba(0, 0, 0, 0.05);
              }
            }
          }
        }
      }

      >.payslip__modal--content-pdf {
        max-width: 300px;
        margin: 20px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;

        >div:nth-child(1) {
          width: 55%;
          padding: 10px 0;
          border-radius: 5px;
          background-color: #5099de;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }

        >div:nth-child(2) {
          width: 35%;
          padding: 10px 0;
          border-radius: 5px;
          background-color: #dcdcdc;
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: center;
          color: #000;
          cursor: pointer;
        }
      }
    }
  }
}

.page__err {
  color: red;
  font-style: italic;
  font-size: 12px;
  text-align: center;
}
</style>
